import { Component, AfterViewInit, inject } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Router } from "@angular/router";
import { finalize } from "rxjs/operators";
import { HttpClient } from "@angular/common/http";

import { IcEnvironment } from "@intocare-medapp/environment";

import { AuthModel, BrowserService, ContextService } from "../../shared";
import { SimpleToastService, SplashScreenService } from "../../shared/modules";
import { LoadingController } from "@ionic/angular";

@Component({
	templateUrl: "terms-conditions.component.html",
	styleUrls: ["terms-conditions.component.scss"],
	standalone: false,
})
export class TermsConditionsComponent implements AfterViewInit {
	private readonly translateService = inject(TranslateService);
	private readonly router = inject(Router);
	private readonly authModel = inject(AuthModel);
	private readonly http = inject(HttpClient);
	private readonly toastService = inject(SimpleToastService);
	private readonly browserService = inject(BrowserService);
	private readonly splashscreenService = inject(SplashScreenService);
	private readonly icEnvironment = inject(IcEnvironment);
	private readonly contextService = inject(ContextService);
	private readonly loadingController = inject(LoadingController);

	private showLoadingDialog() {
		this.loadingController
			.create({
				message: this.translateService.instant("general.saving"),
			})
			.then((loading) => {
				loading.present();
			});
	}

	async accept() {
		await this.showLoadingDialog();

		const baseUrl = this.icEnvironment.getBaseUrlForContext("access");
		const userId = this.contextService.context().user.id;

		this.http.put<void>(`${baseUrl}/users/${userId}/accept-terms-and-conditions`, {}).subscribe({
			next: () => {
				/** FORCE REFETCH OF THE CONTEXT. */
				window.location.replace("/");
			},
			error: () => this.toastService.error(this.translateService.instant("auth.errors.unknown")),
		});
	}

	decline() {
		this.authModel
			.signOut()
			.pipe(
				finalize(() => {
					this.router.navigate(["select-organisation"]);
				}),
			)
			.subscribe();
	}

	openBrowser(url: string) {
		this.browserService.open(url);
	}

	ngAfterViewInit() {
		this.splashscreenService.hide();
	}
}
